import React from 'react'
import Base from './Base'

export default props => (
  <Base {...props} viewBox='0 0 24 24'>
    <path d='M11 17l-5-5 5-5M18 17l-5-5 5-5' />
  </Base>
)
